import styleInject from '../../../../external_node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".esc-button{position:absolute;top:20px;right:46px}@media(max-width: 1240px){.esc-button{right:15px}}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=PurchaseRestrictionPopup.css.js.map
